import { createPreset } from '@media-ui/pypo-article/src/containers/Article/presets/preset';
import ExpertQuote from 'Src/components/Article/components/ExpertQuote';
const expertQuotePreset = createPreset({
    type: 'expert',
})(ExpertQuote);
export default expertQuotePreset;
